import * as React from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Tab, Nav, NavItem, Row, Col } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import StylingFirmsForm from './form/StylingFirmsForm';
import StylingFirmsProductForm from './form/StylingFirmsProductForm';
import FormInputChangeHandler from '../../shared/form/FormInputChangeHandler';
import * as Actions from './actions/StylingFirmsActions';
import { IStylingFirm, IProduct } from './Entities';
import notify from '../../shared/feedback/notifications';
import { assign } from '../../shared/Assign';
import { handleError } from '../../shared/ErrorCatching';
import InvoiceProductTypeListRow from '../invoiceProductType/InvoiceProductTypeListRow';

interface IProps {
    showModal: boolean;
    toggleModal: boolean;
    stylingFirmId: Number;
}

class StylingFirmsModal extends React.Component<any, any> {
    formInputChangeHandler: FormInputChangeHandler;

    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            errors: {},
            stylingFirm: {
                id: 0,
                name: '',
                products: []
            },
            creating: false,
            selectedProduct: { id: -1, name: '' }
        };

        this.save = this.save.bind(this);
        this.formInputChangeHandler = new FormInputChangeHandler(
            this.state.stylingFirm,
            (newState) => {
                this.setState({ stylingFirm: newState });
            }
        );

        this.addProduct = this.addProduct.bind(this);
        this.deleteProduct = this.deleteProduct.bind(this);
        this.selectedProductChanged = this.selectedProductChanged.bind(this);
        this.save = this.save.bind(this);
        this.nameChanged = this.nameChanged.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.actions.getStylingFirmsProducts().catch((error: any) => {
            handleError(error);
            notify.failure(Translate('styling-firms/notification/error/unable-to-fetch-data'));
        });

        if (this.props && this.props.stylingFirmId !== 0) {
            this.props.actions
                .getStylingFirm(this.props.stylingFirmId)
                .then(() => {
                    this.setState({
                        stylingFirm: this.props.stylingFirm
                    });
                })
                .catch((error: any) => {
                    handleError(error);
                    notify.failure(
                        Translate('styling-firms/notification/error/unable-to-fetch-data')
                    );
                });
        }
    }

    componentWillUpdate(nextProps: any) {
        if (
            nextProps.stylingFirm &&
            this.props.stylingfirm &&
            nextProps.stylingFirm !== this.props.stylingfirm
        ) {
            let stylingFirm = assign({}, nextProps.stylingFirm);

            this.setState({ stylingFirm: stylingFirm });
        }
    }

    save() {
        this.setState({ creating: true });

        if (this.props.stylingFirmId && this.props.stylingFirmId !== 0) {
            this.props.actions
                .updateStylingFirm(this.state.stylingFirm)
                .then(() => {
                    this.props.toggleModal();
                    notify.success(Translate('styling-firms/notification/styling-firm-updated'));
                })
                .catch((error: any) =>
                    handleError(error, (errors: any): void => {
                        this.setState({ errors: errors, creating: false });
                    })
                );
        } else {
            this.props.actions
                .addStylingFirm(this.state.stylingFirm)
                .then(() => {
                    this.props.toggleModal();
                    notify.success(Translate('styling-firms/notification/styling-firm-added'));
                })
                .catch((error: any) =>
                    handleError(error, (errors: any): void => {
                        this.setState({ errors: errors, creating: false });
                    })
                );
        }
    }

    addProduct() {
        const firm = assign({}, this.state.stylingFirm);

        firm.products.push(
            this.props.availableproducts.find((product: IProduct) => {
                return product.id == this.state.selectedProduct.id;
            })
        );

        this.setState({
            stylingFirm: firm,
            selectedProduct: { id: -1, name: '' }
        });

        this.formInputChangeHandler.updateObj(firm);
    }

    deleteProduct(e: Number) {
        const product = this.props.availableproducts.find((x) => x.id === e);

        if (product) {
            const firm = assign({}, this.state.stylingFirm);
            const products = firm.products.filter((x) => {
                return x.id !== product.id;
            });

            firm.products = products ? products : [];

            this.setState({
                stylingFirm: firm,
                selectedProduct: { id: -1, name: '' }
            });

            this.formInputChangeHandler.updateObj(firm);
        }
    }

    nameChanged(e) {
        const firm = assign({}, this.state.stylingFirm);

        firm.name = e.currentTarget.value;
        this.setState({
            stylingFirm: firm
        });

        this.formInputChangeHandler.updateObj(firm);
    }

    selectedProductChanged(e: React.FormEvent<HTMLInputElement>) {
        this.setState({ selectedProduct: { id: Number(e.currentTarget.value) } });
    }

    setTabValidationError(...properties: string[]) {
        if (!this.props.errors || Object.keys(this.props.errors).length === 0) {
            return null;
        }

        let hasErrors = properties.some((prop: string) => {
            return this.props.errors[prop] !== undefined;
        });

        return hasErrors ? (
            <i className="material-icons material-icons-danger material-icons-label md-18">error</i>
        ) : null;
    }

    render() {
        return (
            <Modal show={this.props.showModal} onHide={this.props.toggleModal}>
                <Modal.Header closeButton>
                    {this.props.stylingFirmId === 0
                        ? Translate('styling-firms/modal/header/add-firm')
                        : Translate('styling-firms/modal/header/edit-firm')}
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <Tab.Container defaultActiveKey={1} id="uncontrolled-tab">
                            <div>
                                <Nav>
                                    <NavItem eventKey={1}>
                                        {Translate('styling-firms/modal/tab/styling-firm')}
                                        {this.setTabValidationError(
                                            'name',
                                            'username',
                                            'email',
                                            'phoneNumber'
                                        )}
                                    </NavItem>
                                    <NavItem eventKey={2}>
                                        {Translate('styling-firms/modal/tab/styling-products')}
                                        {this.setTabValidationError(
                                            'name',
                                            'username',
                                            'email',
                                            'phoneNumber'
                                        )}
                                    </NavItem>
                                </Nav>
                                <Tab.Content>
                                    <Tab.Pane eventKey={1}>
                                        <fieldset>
                                            <legend>
                                                {Translate(
                                                    'styling-firms/modal/form/legend/styling-firm'
                                                )}
                                            </legend>
                                            <Row>
                                                <Col md={8}>
                                                    <StylingFirmsForm
                                                        errors={this.state.errors}
                                                        stylingFirm={this.state.stylingFirm}
                                                        onChange={this.nameChanged}
                                                    />
                                                </Col>
                                            </Row>
                                        </fieldset>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey={2}>
                                        <fieldset>
                                            <Row>
                                                <Col md={12}>
                                                    <StylingFirmsProductForm
                                                        errors={this.state.errors}
                                                        stylingFirm={this.state.stylingFirm}
                                                        availableProducts={
                                                            this.props.availableproducts
                                                        }
                                                        addProduct={this.addProduct}
                                                        deleteProduct={this.deleteProduct}
                                                        selectedProduct={this.state.selectedProduct}
                                                        selectedProductChanged={
                                                            this.selectedProductChanged
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                        </fieldset>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </Tab.Container>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.toggleModal}>
                        {Translate('styling-firms/modal/footer-button/close')}
                    </Button>
                    <Button bsStyle="primary" disabled={this.state.creating} onClick={this.save}>
                        {this.state.creating
                            ? Translate('styling-firms/modal/footer-button/saving')
                            : Translate('styling-firms/modal/footer-button/save')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            addStylingFirm: (stylingFirm: IStylingFirm) =>
                dispatch(Actions.addStylingFirm(stylingFirm)),
            updateStylingFirm: (stylingFirm: IStylingFirm) =>
                dispatch(Actions.updateStylingFirm(stylingFirm)),
            getStylingFirm: (id: number) => dispatch(Actions.getStylingFirm(id)),
            getStylingFirmsProducts: () => dispatch(Actions.getStylingFirmProducts())
        }
    };
}

function mapStateToProps(state: any) {
    return {
        stylingFirm: state.styling.modal.stylingFirm,
        availableproducts: state.styling.products
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(StylingFirmsModal);
